"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AnimationFrameEngine_animationEngine, _AnimationFrameEngine_uuidGenerator;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimationFrameEngine = void 0;
const TWEEN = __importStar(require("@tweenjs/tween.js"));
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const viewer_rendering_engine_animation_engine_1 = require("@shapediver/viewer.rendering-engine.animation-engine");
class AnimationFrameEngine {
    // #endregion Properties (5)
    // #region Constructors (1)
    constructor() {
        // #region Properties (5)
        _AnimationFrameEngine_animationEngine.set(this, viewer_rendering_engine_animation_engine_1.AnimationEngine.instance);
        _AnimationFrameEngine_uuidGenerator.set(this, viewer_shared_services_1.UuidGenerator.instance);
        this._animationFrameCallbacks = {};
        this._lastTime = 0;
        this.animate(0);
    }
    // #endregion Constructors (1)
    // #region Public Static Accessors (1)
    static get instance() {
        return this._instance || (this._instance = new this());
    }
    // #endregion Public Static Accessors (1)
    // #region Public Methods (2)
    addAnimationFrameCallback(cb) {
        const token = __classPrivateFieldGet(this, _AnimationFrameEngine_uuidGenerator, "f").create();
        this._animationFrameCallbacks[token] = cb;
        return token;
    }
    removeAnimationFrameCallback(token) {
        if (!this._animationFrameCallbacks[token])
            return false;
        delete this._animationFrameCallbacks[token];
        this._animationFrameCallbacks[token] = undefined;
        return true;
    }
    // #endregion Public Methods (2)
    // #region Private Methods (1)
    animate(time) {
        // animation loop - part 2: requesting and timings
        requestAnimationFrame((time) => this.animate(time));
        TWEEN.update(time);
        const deltaTime = time - this._lastTime < 0 ? 0 : time - this._lastTime;
        this._lastTime = time;
        const runningAnimation = __classPrivateFieldGet(this, _AnimationFrameEngine_animationEngine, "f").update(deltaTime);
        for (let a in this._animationFrameCallbacks)
            this._animationFrameCallbacks[a](time, deltaTime, runningAnimation);
    }
}
exports.AnimationFrameEngine = AnimationFrameEngine;
_AnimationFrameEngine_animationEngine = new WeakMap(), _AnimationFrameEngine_uuidGenerator = new WeakMap();
//# sourceMappingURL=AnimationFrameEngine.js.map